import classNames from 'classnames';
import React from 'react';
import Style from 'styles/components/cost_simulation.module.scss';
import useScrollAnimation from 'hooks/useScrollAnimation';

const CostSimulation = () => {
  const [sectionRef, isVisible] = useScrollAnimation(0.1);

  return (
    <section ref={sectionRef} className={classNames(Style.costSim, { [Style.costSimVisible]: isVisible })}>
      <span className={Style.eyebrow}>Cost Simulation</span>
      <h2 className={Style.costSim__title}>comachicartにすると、どれくらいおトク？</h2>
      <p className={Style.costSim__sub}>月商30万円のショップで、年間コストを比較しました。</p>

      {/* 大きな数字 */}
      <div className={Style.big}>
        <div className={Style.big__line}>大手M社と比べて、年間 <span className={Style.big__num}>82,640</span>円おトク</div>
      </div>

      {/* 3社ミニカード */}
      <div className={Style.cards}>
        <div className={classNames(Style.minicard, Style.minicard__accent)}>
          <div className={Style.minicard__name}>comachicart Basic</div>
          <div className={Style.minicard__value}>163,200<span>円/年</span></div>
        </div>
        <div className={Style.minicard}>
          <div className={Style.minicard__name}>大手B社</div>
          <div className={Style.minicard__value}>237,600<span>円/年</span></div>
        </div>
        <div className={Style.minicard}>
          <div className={Style.minicard__name}>大手M社</div>
          <div className={Style.minicard__value}>245,840<span>円/年</span></div>
        </div>
      </div>

      {/* 内訳 Before/After */}
      <div className={Style.detail}>
        <div className={Style.detail__grid}>
          <div className={Style.detailCard}>
            <div className={Style.detailCard__tag}>Before</div>
            <div className={Style.detailCard__name}>大手M社 を使った場合</div>
            <div className={Style.detailCard__rows}>
              <div className={Style.detailCard__row}><span>初期費用</span><span>11,000円</span></div>
              <div className={Style.detailCard__row}><span>月額費用</span><span>10,000円 &times; 12ヶ月</span></div>
              <div className={Style.detailCard__row}><span>決済手数料(3.19%)</span><span>114,840円</span></div>
            </div>
            <div className={Style.detailCard__total}>245,840<small>円/年</small></div>
          </div>

          <div className={Style.detail__arrow}>&rarr;</div>

          <div className={classNames(Style.detailCard, Style.detailCard__after)}>
            <div className={classNames(Style.detailCard__tag, Style.detailCard__tagAfter)}>After</div>
            <div className={Style.detailCard__name}>comachicart Basic を使った場合</div>
            <div className={Style.detailCard__rows}>
              <div className={Style.detailCard__row}><span>初期費用</span><span>0円</span></div>
              <div className={Style.detailCard__row}><span>月額費用</span><span>4,000円 &times; 12ヶ月</span></div>
              <div className={Style.detailCard__row}><span>決済手数料(3.2%)</span><span>115,200円</span></div>
            </div>
            <div className={classNames(Style.detailCard__total, Style.detailCard__totalAfter)}>163,200<small>円/年</small></div>
          </div>
        </div>

        <div className={Style.savingBlock}>
          <div className={Style.savingBlock__label}>comachicart導入で</div>
          <div className={Style.savingBlock__main}>
            <span className={Style.savingBlock__text}>年間</span>
            <span className={Style.savingBlock__num}>82,640</span>
            <span className={Style.savingBlock__text}>円の節約</span>
          </div>
          <div className={Style.savingBlock__sub}>月あたり約6,900円おトク</div>
        </div>
      </div>

      {/* 注意書き */}
      <div className={Style.notice}>
        <p>※ 上記は以下の条件に基づく試算であり、実際の費用はご利用状況により異なります。月商30万円（税込）、売上の全額をクレジットカード（VISA/MASTER）で決済した場合の試算です。comachicart Basicプラン（月額4,000円（税込）、決済手数料3.2%（税抜））で算出しています。他社サービスの料金は各社公式Webサイト掲載情報に基づく当社調べです（2026年3月時点）。クレジットカード以外の決済手段をご利用の場合、手数料体系が異なります。各サービスの機能・仕様は料金以外にも異なります。最新情報は各社公式サイトをご確認ください。</p>
      </div>
    </section>
  );
};

export default CostSimulation;
